/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Where a composite's policies came from. Wider than CompositePricingPolicy.source, which has no companyDefault member: a composite with no row prices off the company default, so absence of a row is what this reports as companyDefault.
 */
export enum CompositePolicySource {
    COMPANY_DEFAULT = 'companyDefault',
    EXCEPTION = 'exception',
    MANUAL = 'manual',
}
